<template>
  <button
    class="modal-btn"
    :class="[`modal-btn--${type}`, { 'modal-btn--disabled': disabled }]"
    :disabled="disabled"
    @click="$emit('click', $event)"
  >
    <slot />
  </button>
</template>

<script>
export default {
  name: 'ModalButton',
  props: {
    type: {
      type: String,
      default: 'secondary',
      validator: v => ['primary', 'danger', 'danger-outline', 'secondary'].includes(v),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
.modal-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  padding: 0 20px;
  border-radius: 8px;
  font-family: Inter, sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 1;
  cursor: pointer;
  border: 1px solid transparent;
  outline: none;
  white-space: nowrap;
  transition: background-color 0.15s ease, box-shadow 0.15s ease;
}

/* Primary */
.modal-btn--primary {
  background: var(--biz-color, #1A365D);
  color: #ffffff;
  border-color: var(--biz-color, #1A365D);
}
.modal-btn--primary:hover:not(:disabled) {
  background: var(--biz-color-hover, #152D4E);
  border-color: var(--biz-color-hover, #152D4E);
}

/* Danger */
.modal-btn--danger {
  background: #E11D48;
  color: #ffffff;
  border-color: #E11D48;
}
.modal-btn--danger:hover:not(:disabled) {
  background: #BE123C;
  border-color: #BE123C;
}

/* Danger outline */
.modal-btn--danger-outline {
  background: #ffffff;
  color: #E11D48;
  border-color: #E11D48;
}
.modal-btn--danger-outline:hover:not(:disabled) {
  background: #FFF1F2;
}

/* Secondary */
.modal-btn--secondary {
  background: #ffffff;
  color: #374151;
  border-color: #D1D5DB;
}
.modal-btn--secondary:hover:not(:disabled) {
  background: #F5F7FA;
}

/* Disabled */
.modal-btn--disabled {
  background: #C4C7CC !important;
  color: #ffffff !important;
  border-color: #C4C7CC !important;
  cursor: not-allowed;
  opacity: 0.8;
}

/* Phase 2 (Tablet 768–1023px): touch targets need >=44px. */
@media (min-width: 600px) and (max-width: 1023px) {
  .modal-btn {
    height: 44px;
  }
}
</style>
